import http from "../classes/http";

export default {
  namespaced: true,
  state: () => ({
    subscribe: '',
    lessons: ''
  }),
  mutations: {
    add_billing_info(store, data){
      store.subscribe = data.subscribe;
      store.lessons = data.lessons;
    }
  },
  actions: {},
  getters: {}
}